// extracted by mini-css-extract-plugin
export default {"SendInvitationDialog":"SendInvitationDialog_SendInvitationDialog__GrEZl"};